// extracted by mini-css-extract-plugin
export default {"vocabulary":"vocabulary_vocabulary__FAfpr","vocabularySearch":"vocabulary_vocabularySearch__7kIPN"};